import React, { ReactNode } from 'react';
import { useFeatureGuard } from '../../graphql/community/hooks/useFeatureGuard';

export interface FeatureGuardProps {
  features: string[];
  children?: ReactNode; // ✅ Add children here
}

export const FeatureGuard: React.FC<FeatureGuardProps> = ({
  features,
  children,
}) => {
  const { communityHasFeatures } = useFeatureGuard();

  return communityHasFeatures(...features) ? <>{children}</> : null;
};
